import { render, staticRenderFns } from "./scoreSetting.vue?vue&type=template&id=669a6fb3&scoped=true&"
import script from "./scoreSetting.vue?vue&type=script&lang=js&"
export * from "./scoreSetting.vue?vue&type=script&lang=js&"
import style0 from "./scoreSetting.vue?vue&type=style&index=0&id=669a6fb3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669a6fb3",
  null
  
)

export default component.exports